// @ts-nocheck
import { useState, useRef, useReducer, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { Fieldset } from 'primereact/fieldset';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';
import { Slider } from 'primereact/slider';
import "../../assets/functionalComponents/_dialog.scss"
import "../../assets/functionalComponents/_dataItem.scss"
import "../../assets/functionalComponents/ScrollPanelDemo.css"

export const ProjectorEntityOption = (props) => {
    const [projectorEntityList, setProjectorEntityList] = useState([]);
    const [indexNum, setIndexNum] = useState("");
    const [resetPosition, setResetPosition] = useState(false);
    const [resetView, setResetView] = useState(false);

    useEffect(() => {
        setProjectorEntityList(props.projectorEntityList);
        setIndexNum(props.indexNum);
    }, [props])

    const setReset = () => {
        props.setLatChange(null);
        props.setLonChange(null);
        props.setHeiChange(null);
        props.setYawChange(null);
        props.setPitChange(null);
    }
   
    let projector = projectorEntityList[indexNum];

    if(projector) {
        return (
            <div>
                <Dialog header="虛實整合影像設定" visible={props.ProjectorSet} position={'right'} modal={false} keepInViewport={false} onHide={() => props.setProjectorSet(false)}>
                    <Fieldset legend="投影機資訊" toggleable>
                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-3 md:mb-0">經度(°E)：</label>
                            <div className="col-12 md:col-3">{projector.entity.getParameter().Pos.x.toFixed(5)}</div>
                            <label className="col-12 mb-4 md:col-3 md:mb-0">緯度(°N)：</label>
                            <div className="col-12 md:col-3">{projector.entity.getParameter().Pos.y.toFixed(5)}</div>
                        </div>
                        <Divider />
                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-3 md:mb-0">高度(公尺)：</label>
                            <div className="col-12 md:col-3">{projector.height}</div>
                            <label className="col-12 mb-4 md:col-3 md:mb-0">投射距離(公尺)：</label>
                            <div className="col-12 md:col-3">{projector.entity.getParameter().Far}</div>
                        </div>
                        <Divider />
                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-3 md:mb-0">方位角：</label>
                            <div className="col-12 md:col-3">{ (360 + projector.yaw ) % 360}</div>
                            <label className="col-12 mb-4 md:col-3 md:mb-0">仰角：</label>
                            <div className="col-12 md:col-3">{ (360 + projector.pitch ) % 360}</div>
                        </div>
                        <Divider />
                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-3 md:mb-0">影片名稱(來源)：</label>
                            <div className="col-12 md:col-3">{projector.source.name ? projector.source.name : projector.source}</div>
                        </div>
                    </Fieldset>
                    <br></br>
                    <Card subTitle='投影機參數設定'>
                        <div  className="projector-item">
                            <Card style={{width: "290px",height: "220px", marginRight: "10px"}}>
                                <p style={{display: "flex", justifyContent: "space-around"}}>投影機位置調整</p>
                                <Divider />
                                {
                                    resetPosition ? 
                                        (
                                            <div>
                                                <div className="projector-action">

                                                    <div style={{display: "flex", flexDirection: "column"}}>
                                                        <div className="projector-action">
                                                            <label style={{marginRight: "3%", width: "30%"}}>經度 :</label>
                                                            <div>
                                                                <InputText placeholder={projector.entity.getParameter().Pos.x.toFixed(5)} onChange={(e) => {props.setLonChange(e.target.value)}} style={{ width: "85%", marginBottom: "5px" }}/>
                                                            </div>
                                                        </div>
                                                        <div className="projector-action">
                                                            <label style={{marginRight: "3%", width: "30%"}}>緯度 :</label>
                                                            <div>
                                                                <InputText placeholder={projector.entity.getParameter().Pos.y.toFixed(5)} onChange={(e) => {props.setLatChange(e.target.value)}} style={{ width: "85%", marginBottom: "5px" }}/>
                                                            </div>
                                                        </div>
                                                        <div className="projector-action">
                                                            <label style={{marginRight: "3%", width: "30%"}}>高度 :</label>
                                                            <div>
                                                                <InputText placeholder={projector.height} onChange={(e) => {props.setHeiChange(e.target.value)}} style={{ width: "85%", marginBottom: "5px" }}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style={{height: "100%", display: "flex", flexDirection: "column"}}>
                                                        <Button label="確定" icon="pi pi-check" className="p-button-raised p-button-info projector-posbutton" onClick={() => { props.changeParam() }} style={{ marginBottom: "20%" }} />
                                                        <Button label="取消" icon="pi pi-times" className="p-button-raised p-button-danger projector-posbutton" onClick={() => { setResetPosition(false) }} />
                                                    </div>


                                                </div>
                                            </div>
                                        )
                                        :
                                        (   
                                            <div>
                                                <div className="field grid">
                                                    <div>
                                                        <Button icon="pi pi-caret-up" className="p-button-raised p-button-info " onClick={() => { props.positionChange("front") }} style={{ width: "35px", height: "35px", left: "70px"}} tooltip="緯度向北0.00001度"/>
                                                        <Button icon="pi pi-caret-up" className="p-button-raised p-button-info " onClick={() => { props.positionChange("up") }} style={{ width: "35px", height: "35px", left: "165px"}} tooltip="高度提升1公尺"/>
                                                    </div>
                                                </div>
                                                <div className="field grid">
                                                    <div>
                                                        <Button icon="pi pi-caret-left" className="p-button-raised p-button-info " onClick={() => { props.positionChange("left")}} style={{ width: "35px", height: "35px", left: "20px"}} tooltip="經度向西0.00001度"/>
                                                        <Button icon="pi pi-refresh" className="p-button-raised p-button-info " onClick={() => { props.startAllOver() }} style={{ width: "35px", height: "35px", left: "35px"}} tooltip="點擊重新選定投影機位置"/>
                                                        <Button icon="pi pi-caret-right" className="p-button-raised p-button-info " onClick={() => { props.positionChange("right") }} style={{ width: "35px", height: "35px", left: "50px"}} tooltip="經度向東0.00001度"/>
                                                        <Button icon="pi pi-pencil" className="p-button-raised p-button-info " onClick={() => { setResetPosition(true); setReset() }} style={{ width: "35px", height: "35px", left: "95px" }} tooltip="手動輸入投影機位置"/>
                                                    </div>
                                                </div>
                                                <div className="field grid">
                                                    <div>
                                                        <Button icon="pi pi-caret-down" className="p-button-raised p-button-info " onClick={() => { props.positionChange("back") }} style={{ width: "35px", height: "35px", left: "70px"}} tooltip="緯度向南0.00001度"/>
                                                        <Button icon="pi pi-caret-down" className="p-button-raised p-button-info " onClick={() => { props.positionChange("down") }} style={{ width: "35px", height: "35px", left: "165px"}} tooltip="高度降低1公尺"/>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                }
                            </Card>
                            <Card style={{width: "210px",height: "220px", marginRight: "10px"}}>
                                <p style={{display: "flex", justifyContent: "space-around" }}>投射方向調整</p>
                                <Divider />
                                {
                                    resetView ? 
                                    (
                                        <div>
                                            <div className="projector-action">
                                                <label style={{marginRight: "3%", width: "45%"}}>方位角 :</label>
                                                <div>
                                                    <InputText placeholder={(360 - projector.yaw ) % 360} onChange={(e) => {props.setYawChange(e.target.value)}} style={{ width: "100%", marginBottom: "5px" }}/>
                                                </div>
                                            </div>
                                            <div className="projector-action">
                                                <label style={{marginRight: "3%", width: "45%"}}>仰角 :</label>
                                                <div>
                                                    <InputText placeholder={(360 + projector.pitch ) % 360} onChange={(e) => {props.setPitChange(e.target.value)}} style={{ width: "100%", marginBottom: "5px" }}/>
                                                </div>
                                            </div>
                                            <div className="field grid" style={{marginTop: "5px"}}>
                                                <div className="col-12 md:col-6">
                                                    <Button label="確定" icon="pi pi-check" className="p-button-raised p-button-info " onClick={() => { props.changeParam() }} style={{ width: "100%"}} />
                                                </div>
                                                <div className="col-12 md:col-6">
                                                    <Button label="取消" icon="pi pi-times" className="p-button-raised p-button-danger " onClick={() => { setResetView(false) }} style={{ width: "100%"}}/>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                    :
                                    (
                                        <div>
                                            <div className="field grid">
                                                <div className="col-12 md:col-12" >
                                                    <Button icon="pi pi-caret-up" className="p-button-raised p-button-info " onClick={() => { props.viewChange("up") }} style={{ width: "35px", height: "35px", left: "75px"}} tooltip="仰角提升1度"/>
                                                </div>
                                            </div>
                                            <div className="field grid">
                                                 <div className="col-12 md:col-4">
                                                    <Button icon="pi pi-caret-left" className="p-button-raised p-button-info " onClick={() => { props.viewChange("left") }} style={{ width: "35px", height: "35px", left: "23px"}} tooltip="方位角向西1度"/>
                                                </div>
                                                <div className="col-12 md:col-4">
                                                    <Button icon="pi pi-pencil" className="p-button-raised p-button-info " onClick={() => { setResetView(true); setReset() }} style={{ width: "35px", height: "35px", left: "8px" }} tooltip="手動輸入投影方向"/>
                                                </div>
                                                <div className="col-12 md:col-4">
                                                    <Button icon="pi pi-caret-right" className="p-button-raised p-button-info " onClick={() => { props.viewChange("right") }} style={{ width: "35px", height: "35px", left: "-8px"}} tooltip="方位角向東1度"/>
                                                </div>
                                            </div>
                                            <div className="field grid">
                                                <div className="col-12 md:col-12" >
                                                    <Button icon="pi pi-caret-down" className="p-button-raised p-button-info " onClick={() => { props.viewChange("down") }} style={{ width: "35px", height: "35px", left: "75px"}} tooltip="仰角降低1度"/>
                                                </div>
                                            </div>
                                        </div>
                                    )


                                }

                            </Card>
                        </div>
                        <br></br>
                        <Card subTitle="投射距離設定">
                            <h5>{projector.entity.getParameter().Far} 公尺</h5>
                            <Slider value={projector.entity.getParameter().Far} onChange={(e) => props.farChange(e.value)} min={5} max={1000} />
                        </Card>
                    </Card>
                </Dialog>
            </div>
        )
    } else {
        return null;
    }
}
